import { apiClient } from "../lib/apiClient";
import type { ImportResultSummary, ParsedImportRow } from "../types";

export interface PreviewResponse {
  rows: ParsedImportRow[];
  summary: { total: number; valid: number; invalid: number };
}

export async function previewImport(eventId: string, csvText: string): Promise<PreviewResponse> {
  const { data } = await apiClient.post<PreviewResponse>(`/events/${eventId}/import/preview`, { csvText });
  return data;
}

export async function commitImport(eventId: string, rows: ParsedImportRow[]): Promise<ImportResultSummary> {
  const { data } = await apiClient.post<{ summary: ImportResultSummary }>(`/events/${eventId}/import/commit`, {
    rows: rows.map((r) => ({
      rowNumber: r.rowNumber,
      parentName: r.parentName,
      phone: r.phone,
      studentName: r.studentName,
      studentIc: r.studentIc,
      age: r.age,
    })),
  });
  return data.summary;
}
